export const LOAD_DU_DATA = 'LOAD_DU_DATA'

export function loadDUDataAction(token){
    return {
        type: LOAD_DU_DATA,
        data: token
    }
}
